import React from 'react';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';
import { showBorrowerNames } from 'utilities/accounting/showBorrowerNames';
import { AddressDisplay } from './AddressDisplay';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { ISearchOrderRequest } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface IExpectedOrderDisplayProps {
  expectedOrder: ISearchOrderRequest;
  actionLabel?: string;
  onAction?: () => void;
}

export const ExpectedOrderDisplay: React.FC<IExpectedOrderDisplayProps> = ({
  expectedOrder,
  actionLabel,
  onAction,
}) => {
  return (
    <div className={'flex w-full flex-row items-center gap-1 px-2 even:bg-slate-100 hover:bg-slate-200'}>
      <div className={'basis-44'}>{getDateString(DateFormat.shortDateTime, expectedOrder.createdAt, true)}</div>
      <div className={'basis-32'}>{expectedOrder.fileNumber}</div>
      <div className={'basis-52'}>{showBorrowerNames(expectedOrder)}</div>
      <div className={'grow'}>
        <AddressDisplay {...expectedOrder.propertyAddress} />
      </div>
      <div className={'basis-40'}></div>
      <div className={'basis-32'}></div>

      {actionLabel && onAction && (
        <ButtonTW className={'basis-36'} onClick={onAction}>
          {actionLabel}
        </ButtonTW>
      )}
      {!actionLabel && !onAction && <div className={'basis-36'}>&nbsp;</div>}
    </div>
  );
};
